// extracted by mini-css-extract-plugin
export default {"pagination-alert":"PaginationAlert_pagination-alert__C+FjU"};